module.exports = __webpack_public_path__ + "img/icon_ht_search.f9acfbab.svg";